import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useStores } from "../../store/index";

const WarningCardBrowswer = () => {
  const { CommonStore } = useStores();
  const chromeLogo =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Google_Chrome_icon_%28September_2014%29.svg/1200px-Google_Chrome_icon_%28September_2014%29.svg.png";
  return (
    <div className="bg-yellow border-l-4 flex flex-row w-[100%] justify-between  border-yellow text-yellow p-3 my-4 rounded relative">
      <div className="flex items-center py-2">
        <div className="flex-shrink-0">
          <img src={chromeLogo} alt="Google Chrome" className="h-8 w-8" />{" "}
          {/* Display the Google Chrome logo */}
        </div>
        <div className="ml-3">
          <p className="text-md gil-med">
            This application only supports Google Chrome browser. Please use
            Google Chrome for the best experience.
          </p>
        </div>
      </div>
      <AiFillCloseCircle
        onClick={() => {
          CommonStore?.setBrowserWarning(false);
        }}
        className="text-yellow text-2xl cursor-pointer"
      />
    </div>
  );
};

export default WarningCardBrowswer;
